webpackJsonp([26],{

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(743),
  /* template */
  __webpack_require__(816),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_handy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_auth__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_tel_input_vuetify__ = __webpack_require__(150);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['action'],
  components: {
    'vue-tel-input-vuetify': __WEBPACK_IMPORTED_MODULE_4_vue_tel_input_vuetify__["a" /* VueTelInputVuetify */]
  },
  data: function data() {
    return {
      tab: null,
      // tabitems: config.IS_OTHER_USER ? ['Personal'] : ['Personal', 'Unit', 'Daily Helper'],
      tabitems: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.IS_OTHER_USER ? ['Personal'] : ['Personal', 'Unit'],
      sbar: false,
      sbarMsg: '',
      sbarCol: 'info',
      rules: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.rules,
      handy: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a,
      otp: '',
      config: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a,
      beingSaved: false,

      // personal
      profile: {},
      commName: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_NAME,
      roleName: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.ROLE_NAME,
      avatarURL: !__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.AVATAR_URL.includes('base64') ? __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.STATIC_FILES_DIR + __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.AVATAR_URL : __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.AVATAR_URL, // image from db or recently changed cache
      isMC: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.IS_MC_MEMBER,
      isAdmin: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.IS_ADMIN,
      isFM: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.IS_FM,
      isOtherUser: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.IS_OTHER_USER,
      hideContact: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.HIDE_CONTACT,
      vdoDlg: false,
      localMediaStream: null,
      canSendOTP: false,
      isValidNumber: false,
      isValidNumberDailyHelp: false,
      // unit

      unit: {},
      users: [],
      occupants: [],
      // Vehicle
      vehHead: [{ text: 'Type', value: 'veh_type' }, { text: 'Vehicle No', value: 'veh_no' }, { text: 'Sticker?', value: 'has_got_sticker' }],
      vehHeadSm: [{ text: 'Unit', value: 'unit' }, { text: 'Type', value: 'veh_type' }, { text: 'Vehicle No', value: 'veh_no' }, { text: 'Sticker?', value: 'has_got_sticker' }],
      vehicles: [],
      vehicle: this.getEmptyVeh(),
      lAction: 'view',
      // daily helpers
      dailyHelpSubCat: ['Maid', 'Nanny', 'Driver', 'Cook', 'Others'],
      dhHead: [{ text: 'Photo', value: 'visitor_img_url' }, { text: 'Name', value: 'visitor_name' }, { text: 'Mobile Number', value: 'visitor_phone' }],
      dhHeadSm: [{ text: 'Photo', value: 'visitor_img_url' }, { text: 'Name', value: 'visitor_name' }, { text: 'Mobile Number', value: 'visitor_phone' }, { text: 'Type', value: 'visitor_sub_cat' }],
      myDailyHelps: [],
      dailyHelpList: [],
      lDailyHelp: { ratings: '', myratings: '' },
      rDailyHelp: '',
      lRatings: '',
      beingRated: false,
      viewDailyHelpDlg: false,
      repDailyHelpDlg: false,
      rateDailyHelpDlg: false,
      dailyHelpAction: 'view',
      userHead: [{ text: 'Name', value: 'cust_name', width: '250px' }, { text: 'Ownership', value: 'ownership', width: '25px' }, { text: 'Status', value: 'rel_status', width: '25px' }, { text: '', value: 'action' }],
      userHeadSm: [{ text: 'Photo', value: 'avatar_url' }, { text: 'Name', value: 'cust_name' }, { text: 'Mobile', value: 'contact_phone' }, { text: 'Ownership', value: 'ownership' }, { text: 'Status', value: 'rel_status' }, { text: '', value: 'action' }],
      occHeadSm: [{ text: 'Name', value: 'cust_name' }, { text: 'Mobile', value: 'contact_phone' }, { text: 'Ownership', value: 'ownership' }, { text: 'Status', value: 'rel_status' }, { text: '', value: 'action' }],
      vehicleTypes: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_COUNTRY_CODE === 'MY' ? ['Car', 'Motorcycle'] : ['Car', 'Two Wheeler']
    };
  },
  created: function created() {
    var _this = this;

    var qry = {
      params: {
        user_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID,
        comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
      }
      // load user profile and corresponding details
    };this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getCustByUserId/', qry).then(function (response) {
      _this.profile = response.data[0];

      // unit details if he is normal resident
      if (!_this.isOtherUser) {
        // load user details
        _this.loadUsers(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.UNITS[0], 0);
        // load occupancy details
        // this.loadOcc()
        // load vehicle Details
        _this.loadVeh();
        // load daily helpers Details. This is not required for app.uniservice.in
        // this.loadMyDailyHelpers()
      }
    }).catch(function (err) {
      _this.msg(err.response.data);
    });
  },
  mounted: function mounted() {
    // default tab
    if (this.action === 'join') {
      // coming from dashboard to approve joining req
      this.tab = 1;
    }
  },

  methods: {
    msg: function msg(m) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (type === 0) {
        this.sbarCol = 'error';
      } else if (type === 1) {
        this.sbarCol = 'success';
      } else {
        this.sbarCol = 'info';
      }
      this.sbar = true;
      this.sbarMsg = m;
    },
    pickAvatar: function pickAvatar() {
      this.$refs.fileInput.click();
    },
    prepareCamera: function prepareCamera() {
      var _this2 = this;

      if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
        alert('Sorry, your browser does not support this feature\nTry using google chrome');
        return;
      }

      // start camera and play
      navigator.mediaDevices.getUserMedia({ video: true }).then(function (stream) {
        // success
        _this2.vdoDlg = true;
        document.querySelector('video').srcObject = stream;
        _this2.localMediaStream = stream;
      }).catch(function (error) {
        console.error('Webcam access is rejected: ' + error);
      });
    },
    capturePhoto: function capturePhoto() {
      var canvas = document.createElement('canvas');
      var video = document.querySelector('#cam');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0);
      this.avatarURL = canvas.toDataURL('image/png');
      this.vdoDlg = false;
      // stop the camera
      var tracks = this.localMediaStream.getTracks();
      tracks.forEach(function (track) {
        track.stop();
      });
      this.localMediaStream.srcObject = null;
    },
    loadAvatarFromFile: function loadAvatarFromFile(event) {
      var _this3 = this;

      var files = event.target.files;
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function () {
        _this3.avatarURL = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
    },
    closeVdoDlg: function closeVdoDlg() {
      this.vdoDlg = false;
    },
    cancelChanges: function cancelChanges() {
      this.$router.go(-1);
    },
    validateAndSave: function validateAndSave() {
      var _this4 = this;

      // validate and go ahead
      if (this.tab === 0 || this.tab === 1) {
        if (this.tab === 0) {
          setTimeout(function () {
            if (_this4.$refs.frmPersonal.validate()) {
              // validate OTP in case changed
              _this4.profile.contact_phone = _this4.profile.contact_phone.replace(/ /g, '');
              if (__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.MOBILE_NO !== _this4.profile.contact_phone) {
                _this4.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/otp/verify', { contact_phone: _this4.profile.contact_phone, purpose: 'joining', otp: _this4.otp }).then(function (response) {
                  _this4.saveChanges();
                }).catch(function (err) {
                  _this4.msg(err.response.data);
                  return;
                });
              } else {
                _this4.saveChanges();
              }
            } else {
              _this4.msg('Enter the required values highlighted above');
            }
          }, 500);
        } else {
          if (this.$refs.frmUnit.validate()) {
            this.saveChanges();
          }
        }
      } else {
        this.saveChanges(); // validate happens in save changes
      }
    },
    saveChanges: function saveChanges(curUnit) {
      var _this5 = this;

      var isRentedChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // 1. update personal/unit details
      if (this.tab === 0) {
        // validation already happened in above function
        this.profile.comm_id = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID;
        this.profile.is_other_user = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.IS_OTHER_USER;
        this.profile.is_mc_member = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.IS_MC_MEMBER;
        this.profile.hide_contact = this.hideContact;
        this.profile.avatar_url = this.avatarURL;
        this.profile.is_self_service = true;
        this.beingSaved = true;
        this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/resident/update', this.profile).then(function (response) {
          _this5.msg('Saved successfully', 1);

          // refresh cache
          __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.CUST_NAME = _this5.profile.cust_name;
          __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.EMAIL_ID = _this5.profile.contact_email;
          __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.HIDE_CONTACT = _this5.hideContact;
          __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.AVATAR_URL = _this5.avatarURL;
          // check for mobile number change - relogin
          if (__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.MOBILE_NO !== _this5.profile.contact_phone) {
            _this5.otp = '';
            __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.MOBILE_NO = _this5.profile.contact_phone;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["e" /* login */])(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID, __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.MOBILE_NO);
            // delete the temporary joinee record
            _this5.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/otp/delete-joinee', { contact_phone: _this5.profile.contact_phone });
          }
          _this5.beingSaved = false;
        }).catch(function (err) {
          _this5.msg(err.response.data);
          _this5.beingSaved = false;
        });
      } else if (this.tab === 1) {
        // 1.1 unit properties
        if (isRentedChange && !curUnit.is_rented && this.users[curUnit.unit_id] && this.users[curUnit.unit_id].findIndex(function (rec) {
          return rec.ownership.toLowerCase().includes('tenant') && rec.rel_status === 'Linked';
        }) >= 0) {
          if (!confirm('WARNING: This action will delink all your tenants and revoke their access from this house automatically')) {
            curUnit.is_rented = true; // reverse the change
            this.$forceUpdate();
            return;
          }
        }
        curUnit.is_self_service = true;
        curUnit.user_id = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID;
        curUnit.is_billed_to_tenant = curUnit.is_rented ? curUnit.is_billed_to_tenant : false;
        this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/unit/update', curUnit).then(function (response) {
          _this5.refreshUnitDet();
        }).catch(function (err) {
          _this5.msg(err.response.data);
        });
      } else if (this.tab === 2) {
        // 2. vehicle
        if (this.$refs.frmVeh.validate() || this.lAction === 'delete') {
          this.vehicle.comm_id = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID;
          this.vehicle.user_id = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID;
          this.beingSaved = true;
          this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/vehicle/' + this.lAction, this.vehicle).then(function (response) {
            // refresh list and go back
            _this5.loadVeh();
            _this5.lAction = 'view';
            _this5.beingSaved = false;
          }).catch(function (err) {
            _this5.msg(err.response.data);
            _this5.beingSaved = false;
          });
        }
      }
    },
    // save changes

    sendOTP: function sendOTP() {
      var _this6 = this;

      if (!this.isValidNumber) {
        this.msg('Invalid mobile number');
        return;
      }
      this.profile.contact_phone = this.profile.contact_phone.replace(/ /g, '');
      // validate for fresh user if user wishes to change his/her mobile no
      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID,
          contact_phone: this.profile.contact_phone
        }
      };
      this.profile.contact_phone = this.profile.contact_phone.substring(0, 15);
      if (this.profile.contact_phone !== __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.MOBILE_NO) {
        this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getUserByPhone/', qry).then(function (response) {
          if (response.data.length > 0) {
            _this6.msg('Another user already exist with this mobile number');
            return;
          } else {
            // send otp
            _this6.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/otp/send', { contact_phone: _this6.profile.contact_phone, purpose: 'joining', country_code: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_COUNTRY_CODE }).then(function (response) {
              _this6.msg('An OTP is sent to your mobile. Please check and enter here', 2);
            }).catch(function (err) {
              _this6.msg(err.response.data);
            });
          }
        });
      }
    },
    // send OTP
    loadUsers: function loadUsers(curUnit, idx) {
      var _this7 = this;

      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          unit_id: curUnit.unit_id
        }
        // load users of all units belong to this user
      };this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getUserByUnitId/', qry).then(function (response) {
        _this7.users[curUnit.unit_id] = response.data;
        _this7.$forceUpdate();
        // recurse through all units
        if (idx < __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.UNITS.length - 1) {
          ++idx;
          _this7.loadUsers(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.UNITS[idx], idx);
        }
      }).catch(function (err) {
        _this7.msg(err.response.data);
        _this7.users[curUnit.unit_id] = [];
      });
    },
    acceptRejReq: function acceptRejReq(curAct, curUser, curUnit) {
      var _this8 = this;

      if (curAct === 'accept-req' && curUser.ownership.toLowerCase().includes('tenant') && !curUnit.is_rented) {
        if (!confirm('Please note that the house will be marked as rented upon accepting tenant\'s joining request')) {
          return;
        }
      }
      // accept or reject
      curUser.actioned_by = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID;
      this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/admin/' + curAct, curUser).then(function (response) {
        // refresh list in front end
        if (curAct === 'reject-req') {
          curUser.rel_status = 'Rejected';
        } else {
          curUser.rel_status = 'Linked';
          if (curUser.ownership.toLowerCase().includes('tenant')) {
            curUnit.is_rented = true;
          }
        }
        _this8.$forceUpdate();
      }).catch(function (err) {
        _this8.msg(err.response.data);
      });
    },
    userUpdate: function userUpdate(curAct, curUser, curUnit) {
      var _this9 = this;

      if (curAct === 'delink') {
        var warnText = '';
        if (curUser.user_id === __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID) {
          warnText = 'Sure, you want to disassociate yourself from unit "' + curUser.unit_no + '"?';
          warnText += '\nWARNING: If you do so, you might not be able log into app at all';
        } else {
          warnText = 'Sure, you want to disassociate the user from unit "' + curUser.unit_no + '"?';
          warnText += '\nWARNING: If you do so, user might not be able log into app at all';
        }
        if (!confirm(warnText)) {
          return;
        }
      } else if (curUser.ownership.toLowerCase().includes('tenant') && !curUnit.is_rented) {
        if (!confirm('Please note that the house will be marked as rented upon linking the tenant')) {
          return;
        }
      }

      // link or delink
      curUser.actioned_by = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID;
      this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/admin/' + curAct, curUser).then(function (response) {
        // refresh list in front end
        if (curAct === 'delink') {
          curUser.rel_status = 'Delinked';
        } else {
          curUser.rel_status = 'Linked';
          if (curUser.ownership.toLowerCase().includes('tenant')) {
            curUnit.is_rented = true;
          }
        }
        _this9.$forceUpdate();
      }).catch(function (err) {
        _this9.msg(err.response.data);
      });
    },


    /* all functions related to vehicle */

    getEmptyVeh: function getEmptyVeh() {
      return {
        veh_id: '',
        unit_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.UNITS[0].unit_id,
        veh_type: '',
        veh_no: '',
        has_got_sticker: false
      };
    },
    loadVeh: function loadVeh() {
      var _this10 = this;

      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          unit_id_list: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.UNIT_ID_LIST
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getVehiclesByUnitIds/', qry).then(function (response) {
        _this10.vehicles = response.data;
      });
    },
    createVeh: function createVeh() {
      this.lAction = 'create';
      // get ready for create with empty vehicle
      this.vehicle = this.getEmptyVeh();
    },
    updateVeh: function updateVeh(item) {
      // load chosen vehicle for update
      this.vehicle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.lAction = 'update';
    },
    cancelVeh: function cancelVeh() {
      // refresh the list
      this.loadVeh();
      this.lAction = 'view';
    },
    deleteVeh: function deleteVeh() {
      // confirm
      if (confirm('Sure, you want to delete the vehicle "' + this.vehicle.veh_no + '"?')) {
        // delete
        this.lAction = 'delete';
        this.validateAndSave();
      }
    },


    /* all functions related to daily helper */
    loadMyDailyHelpers: function loadMyDailyHelpers() {
      var _this11 = this;

      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          unit_id_list: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.PRIVATE_UNIT_ID_LIST
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getDailyHelperByUnitIds/', qry).then(function (response) {
        _this11.myDailyHelps = response.data;
      });
    },
    prepareAddDailyHelp: function prepareAddDailyHelp() {
      var _this12 = this;

      // get ready for adding a daily helper
      // load daily helpers of this community
      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getDailyHelperByCommId/', qry).then(function (response) {
        _this12.dailyHelpList = response.data;
      }).catch(function (err) {
        _this12.msg(err.response.data);
        _this12.dailyHelpList = [];
      });
      this.dailyHelpAction = 'add';
    },
    refreshUnitDet: function refreshUnitDet() {
      // users unit (one or more in this community)
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getUnitsByUserId/' + __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID + '/' + __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.UNITS = response.data;

        // check user has more than one unit in this community
        __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_HAS_MORE_UNITS = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.UNITS.length > 1;
        __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.UNIT_ID_LIST = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.UNITS.filter(function (rec) {
          return rec.rel_status === 'Linked';
        });
        if (__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.UNIT_ID_LIST.length) {
          __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.UNIT_ID_LIST = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.UNIT_ID_LIST.map(function (rec) {
            return rec.unit_id;
          });
        }

        // list of units which needs privacy (used mostly in security module)
        __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.PRIVATE_UNIT_ID_LIST = [];
        __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.UNITS.forEach(function (unit) {
          if (unit.is_rented) {
            if (unit.ownership.toLowerCase().includes('tenant')) {
              // rented units are private to tenants
              __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.PRIVATE_UNIT_ID_LIST.push(unit.unit_id);
            }
          } else {
            // not-rented, not private to anyone
            __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.PRIVATE_UNIT_ID_LIST.push(unit.unit_id);
          }
        });
        __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_HAS_MORE_PRIVATE_UNITS = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.PRIVATE_UNIT_ID_LIST.length > 1;
      }).catch(function (error) {
        alert(error.response.data);
        return;
      });
    },
    ignoreBackspace: function ignoreBackspace(e) {
      if (e.key === 'Backspace') {
        var start = this.profile.contact_phone.length - 1;
        this.profile.contact_phone = this.profile.contact_phone.substring(0, start);
        e.preventDefault();
      }
    },
    keepCursor: function keepCursor() {
      this.$refs.refMob.cursorPosition = this.profile.contact_phone.length;
    },
    validateMob: function validateMob(_ref) {
      var number = _ref.number,
          valid = _ref.valid,
          country = _ref.country;

      this.isValidNumber = valid;
      if (valid) {
        this.profile.contact_phone = number.e164;
        this.profile.phone_country = country.name && country.name.includes('(') ? country.name.substring(0, country.name.indexOf('(') - 1) : country.name;
      }
    },
    viewDailyHelp: function viewDailyHelp(curDailyHelp) {
      this.lDailyHelp = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, curDailyHelp);
      // load ratings of this daily helper
      this.loadDailyHelpRatings(this.lDailyHelp);
      this.viewDailyHelpDlg = true;
    },
    loadDailyHelpRatings: function loadDailyHelpRatings(curHelper) {
      var _this13 = this;

      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          easypass_id: curHelper.easypass_id
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getDailyHelperRatings/', qry).then(function (response) {
        _this13.lRatings = {};
        _this13.lRatings.detail = response.data;
        _this13.lRatings.myratings = response.data.find(function (rec) {
          return rec.user_id === __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID;
        });
        // stats
        _this13.lRatings.no_of_rating = _this13.lRatings.detail.length;
        _this13.lRatings.no_of_review = _this13.lRatings.detail.filter(function (rec) {
          return rec.review;
        }).length;
        _this13.lRatings.avg_overall_rating = _this13.lRatings.detail.map(function (rec) {
          return rec.overall_rating;
        }).reduce(function (a, b) {
          return a + b;
        }, 0) / _this13.lRatings.detail.length;
        _this13.lRatings.avg_skill = _this13.lRatings.detail.map(function (rec) {
          return rec.skill;
        }).reduce(function (a, b) {
          return a + b;
        }, 0) / _this13.lRatings.detail.length;
        _this13.lRatings.avg_regular = _this13.lRatings.detail.map(function (rec) {
          return rec.regular;
        }).reduce(function (a, b) {
          return a + b;
        }, 0) / _this13.lRatings.detail.length;
        _this13.lRatings.avg_loyal = _this13.lRatings.detail.map(function (rec) {
          return rec.loyal;
        }).reduce(function (a, b) {
          return a + b;
        }, 0) / _this13.lRatings.detail.length;
        _this13.lRatings.avg_easygoing = _this13.lRatings.detail.map(function (rec) {
          return rec.easygoing;
        }).reduce(function (a, b) {
          return a + b;
        }, 0) / _this13.lRatings.detail.length;
        _this13.$forceUpdate();
      });
    },
    showDailyHelpRating: function showDailyHelpRating(isRated) {
      var curHelper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (curHelper) {
        // show ratings of requested helper
        this.loadDailyHelpRatings(curHelper);
        this.beingRated = false;
      } else {
        // show ratings of helper being viewed (lDailyHelp)
        if (isRated) {
          this.beingRated = true;
          this.rDailyHelp = this.lRatings.myratings || {};
          this.rDailyHelp.user_already_rated = this.lRatings.myratings && this.lRatings.myratings.overall_rating;
          this.rDailyHelp.user_id = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID;
          this.rDailyHelp.easypass_id = this.lDailyHelp.easypass_id;
          this.rDailyHelp.rated_on = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(new Date());
        } else {
          this.beingRated = false;
        }
      }
      this.rateDailyHelpDlg = true;
    },
    rateDailyHelp: function rateDailyHelp() {
      var _this14 = this;

      this.rDailyHelp.comm_id = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID;
      this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/daily-helper/rate', this.rDailyHelp).then(function (response) {
        // refresh front end
        _this14.rateDailyHelpDlg = false;
        _this14.viewDailyHelp(_this14.lDailyHelp);
      }).catch(function (err) {
        console.log(err);
        _this14.msg(err.response.data);
      });
    },
    showRepDelDailyHelp: function showRepDelDailyHelp() {
      this.lDailyHelp.rep_del_reason = 'D';
      this.repDailyHelpDlg = true;
    },
    repDelDailyHelp: function repDelDailyHelp() {
      var _this15 = this;

      // confirm
      if (confirm('Sure, you want to delete "' + this.lDailyHelp.visitor_name + '"?')) {
        this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/daily-helper/delete', { easypass_id: this.lDailyHelp.easypass_id, unit_id: this.lDailyHelp.unit_id, comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID, user_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID }).then(function (response) {
          // refresh front end
          _this15.repDailyHelpDlg = false;
          _this15.viewDailyHelpDlg = false;
          _this15.loadMyDailyHelpers();
        }).catch(function (err) {
          _this15.msg(err.response.data);
        });
      }
    },
    addDailyHelper: function addDailyHelper(curHelper) {
      var _this16 = this;

      if (confirm('Sure, you want to add "' + curHelper.visitor_name + '" to your unit?')) {
        this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/daily-helper/add', { easypass_id: curHelper.easypass_id, unit_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.PRIVATE_UNIT_ID_LIST[0], comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID, user_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID }).then(function (response) {
          // refresh front end
          _this16.loadMyDailyHelpers();
          _this16.dailyHelpAction = 'view';
        }).catch(function (err) {
          _this16.msg(err.response.data);
        });
      }
    }
  } // methods
});

/***/ }),

/***/ 816:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tabs', {
    attrs: {
      "color": "primary",
      "dark": "",
      "fixed-tabs": "",
      "grow": "",
      "height": "40"
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tabs-slider'), _vm._v(" "), _vm._l((_vm.tabitems), function(tabitem) {
    return _c('v-tab', {
      key: tabitem
    }, [_vm._v("\n      " + _vm._s(tabitem) + "\n    ")])
  })], 2), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: 0
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "frmPersonal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateAndSave()
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "20px",
      "right": "20px"
    }
  }, [_c('v-avatar', {
    staticClass: "grey lighten-4",
    attrs: {
      "size": 120
    }
  }, [(_vm.avatarURL) ? _c('img', {
    attrs: {
      "src": _vm.avatarURL
    }
  }) : _c('v-icon', {
    attrs: {
      "color": "grey",
      "size": "110px"
    }
  }, [_vm._v("person")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.loadAvatarFromFile
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickAvatar
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.prepareCamera
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("photo_camera")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name",
      "rules": [_vm.rules.required],
      "maxlength": "50"
    },
    model: {
      value: (_vm.profile.cust_name),
      callback: function($$v) {
        _vm.$set(_vm.profile, "cust_name", $$v)
      },
      expression: "profile.cust_name"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Gender",
      "items": ['Male', 'Female'],
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.profile.gender),
      callback: function($$v) {
        _vm.$set(_vm.profile, "gender", $$v)
      },
      expression: "profile.gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('vue-tel-input-vuetify', {
    ref: "refMob",
    attrs: {
      "label": "Mobile number",
      "placeholder": "Enter a mobile number",
      "rules": [_vm.rules.required],
      "input-options": {
        showDialCode: true
      }
    },
    on: {
      "input": _vm.keepCursor,
      "validate": _vm.validateMob
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.ignoreBackspace($event)
      }
    },
    model: {
      value: (_vm.profile.contact_phone),
      callback: function($$v) {
        _vm.$set(_vm.profile, "contact_phone", $$v)
      },
      expression: "profile.contact_phone"
    }
  })], 1), _vm._v(" "), (_vm.config.MOBILE_NO !== this.profile.contact_phone) ? _c('v-flex', {
    staticClass: "warning px-2 pt-2 mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "caption",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("Mobile number change deducted. Press send OTP after changing the number to get it validated.")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "type": "number",
      "placeholder": "Enter OTP",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.otp),
      callback: function($$v) {
        _vm.otp = $$v
      },
      expression: "otp"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.sendOTP
    }
  }, [_vm._v("Send OTP")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.config.MOBILE_NO !== this.profile.contact_phone) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "rules": [_vm.rules.required, _vm.rules.email],
      "maxlength": "50"
    },
    model: {
      value: (_vm.profile.contact_email),
      callback: function($$v) {
        _vm.$set(_vm.profile, "contact_email", $$v)
      },
      expression: "profile.contact_email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 py-0 mb-3",
    attrs: {
      "disabled": _vm.isMC || _vm.isFM,
      "label": "Hide contact info from others",
      "hint": "Not possible if you are a MC member or FM ;)",
      "persistent-hint": "",
      "outline": ""
    },
    model: {
      value: (_vm.hideContact),
      callback: function($$v) {
        _vm.hideContact = $$v
      },
      expression: "hideContact"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Other Information")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Emergency phone",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.profile.emergency_phone),
      callback: function($$v) {
        _vm.$set(_vm.profile, "emergency_phone", $$v)
      },
      expression: "profile.emergency_phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Contact name",
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.profile.emergency_contact_name),
      callback: function($$v) {
        _vm.$set(_vm.profile, "emergency_contact_name", $$v)
      },
      expression: "profile.emergency_contact_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Contact relationship",
      "items": ['Spouse', 'Father', 'Mother', 'Son', 'Daughter'],
      "maxlength": "15",
      "hide-details": ""
    },
    model: {
      value: (_vm.profile.emergency_contact_relation),
      callback: function($$v) {
        _vm.$set(_vm.profile, "emergency_contact_relation", $$v)
      },
      expression: "profile.emergency_contact_relation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Blood group",
      "hide-details": "",
      "maxlength": "10"
    },
    model: {
      value: (_vm.profile.blood_group),
      callback: function($$v) {
        _vm.$set(_vm.profile, "blood_group", $$v)
      },
      expression: "profile.blood_group"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Occupation",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.profile.occupation),
      callback: function($$v) {
        _vm.$set(_vm.profile, "occupation", $$v)
      },
      expression: "profile.occupation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Hobbies",
      "maxlength": "50"
    },
    model: {
      value: (_vm.profile.hobbies),
      callback: function($$v) {
        _vm.$set(_vm.profile, "hobbies", $$v)
      },
      expression: "profile.hobbies"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Address")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Address",
      "hide-details": "",
      "maxlength": "150"
    },
    model: {
      value: (_vm.profile.address),
      callback: function($$v) {
        _vm.$set(_vm.profile, "address", $$v)
      },
      expression: "profile.address"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "City",
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.profile.city),
      callback: function($$v) {
        _vm.$set(_vm.profile, "city", $$v)
      },
      expression: "profile.city"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.config.COMM_COUNTRY_CODE === 'MY' ? 'Postal Code' : 'PIN Code',
      "hide-details": "",
      "maxlength": "10"
    },
    model: {
      value: (_vm.profile.pin_code),
      callback: function($$v) {
        _vm.$set(_vm.profile, "pin_code", $$v)
      },
      expression: "profile.pin_code"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "State",
      "maxlength": "25"
    },
    model: {
      value: (_vm.profile.state),
      callback: function($$v) {
        _vm.$set(_vm.profile, "state", $$v)
      },
      expression: "profile.state"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Country",
      "maxlength": "50"
    },
    model: {
      value: (_vm.profile.country),
      callback: function($$v) {
        _vm.$set(_vm.profile, "country", $$v)
      },
      expression: "profile.country"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.config.IS_TAX_APP) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Tax Information")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "GST Identification No.",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.profile.gst_no),
      callback: function($$v) {
        _vm.$set(_vm.profile, "gst_no", $$v)
      },
      expression: "profile.gst_no"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isMC || _vm.isAdmin) ? _c('div', {
    staticClass: "mt-3 mx-auto"
  }, [(_vm.isMC) ? _c('v-chip', {
    attrs: {
      "color": "primary white--text",
      "disabled": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("star")]), _vm._v(_vm._s(_vm.roleName))], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('v-chip', {
    attrs: {
      "color": "primary white--text",
      "disabled": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("supervisor_account")]), _vm._v("Admin")], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        _vm.canSendOTP = false, _vm.cancelChanges()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.config.IS_OTHER_USER) ? _c('v-tab-item', {
    key: 1
  }, [_c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "frmUnit",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateAndSave()
      }
    }
  }, _vm._l((_vm.config.UNITS), function(unit, i) {
    return _c('v-card', {
      key: i,
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "primary lighten-2"
    }, [_c('v-container', {
      staticClass: "pa-0",
      attrs: {
        "grid-list-md": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "white--text title",
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.commName) + "\n                      ")]), _vm._v(" "), _c('v-flex', {
      staticClass: "yellow--text subheading",
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n                        " + _vm._s(unit.block_nm + ' ' + unit.unit_no) + " "), (unit.bhk || unit.acc_sqft) ? _c('span', [_vm._v("- "), (unit.bhk) ? _c('span', [_vm._v(_vm._s(unit.bhk) + " BHK, ")]) : _vm._e(), (unit.acc_sqft) ? _c('span', [_vm._v(_vm._s(unit.acc_sqft) + " sqft ")]) : _vm._e()]) : _vm._e(), _vm._v("(" + _vm._s(unit.ownership) + ")\n                      ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('v-switch', {
      staticClass: "ma-0",
      attrs: {
        "label": "Rented out",
        "hide-details": "",
        "disabled": unit.ownership.toLowerCase().includes('tenant')
      },
      on: {
        "change": function($event) {
          return _vm.saveChanges(unit, true)
        }
      },
      model: {
        value: (unit.is_rented),
        callback: function($$v) {
          _vm.$set(unit, "is_rented", $$v)
        },
        expression: "unit.is_rented"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-switch', {
      staticClass: "ma-0",
      attrs: {
        "label": 'Bill to tenant' + (_vm.users[unit.unit_id] && _vm.users[unit.unit_id].findIndex(function (rec) { return rec.ownership.toLowerCase().includes('tenant'); }) === -1 && unit.is_rented ? ' (No tenant info available)' : ''),
        "hide-details": "",
        "disabled": unit.ownership.toLowerCase().includes('tenant') || (_vm.users[unit.unit_id] && _vm.users[unit.unit_id].findIndex(function (rec) { return rec.ownership.toLowerCase().includes('tenant'); }) === -1 || !unit.is_rented)
      },
      on: {
        "change": function($event) {
          return _vm.saveChanges(unit)
        }
      },
      model: {
        value: (unit.is_billed_to_tenant),
        callback: function($$v) {
          _vm.$set(unit, "is_billed_to_tenant", $$v)
        },
        expression: "unit.is_billed_to_tenant"
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
      staticClass: "ma-2"
    }, [_c('v-card-title', {
      staticClass: "pa-2 grey lighten-4"
    }, [_c('div', {
      staticClass: "title grey--text"
    }, [_vm._v("Uniservice users from this unit")])]), _vm._v(" "), _c('v-data-table', {
      attrs: {
        "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.userHeadSm : _vm.userHead,
        "items": _vm.users[unit.unit_id],
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [(_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_c('v-avatar', {
            attrs: {
              "slot": "activator",
              "size": "36px"
            },
            slot: "activator"
          }, [_c('img', {
            attrs: {
              "src": _vm.config.STATIC_FILES_DIR + props.item.avatar_url
            }
          })])], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(props.item.cust_name) + "\n                    ")]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.contact_phone))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(props.item.ownership) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(!props.item.is_active ? 'Disabled' : props.item.rel_status) + "\n                    ")]), _vm._v(" "), (!unit.ownership.toLowerCase().includes('tenant')) ? _c('v-menu', {
            staticClass: "mt-2",
            attrs: {
              "bottom": "",
              "left": ""
            }
          }, [_c('v-btn', {
            staticClass: "ma-0",
            attrs: {
              "slot": "activator",
              "small": "",
              "icon": ""
            },
            slot: "activator"
          }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [(props.item.rel_status === 'Pending Approval' || props.item.rel_status === 'Rejected') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.acceptRejReq('accept-req', props.item, unit)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("check")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Approve request")])], 1) : _vm._e(), _vm._v(" "), (props.item.rel_status === 'Pending Approval') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.acceptRejReq('reject-req', props.item, unit)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Reject request")])], 1) : _vm._e(), _vm._v(" "), (props.item.rel_status === 'Linked') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.userUpdate('delink', props.item, unit)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Delink from this unit")])], 1) : (props.item.rel_status === 'Delinked') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.userUpdate('link', props.item, unit)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("link")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Link to this unit")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)]
        }
      }], null, true)
    })], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (!_vm.config.IS_OTHER_USER) ? _c('v-tab-item', {
    key: 2
  }, [_c('v-container', {
    staticClass: "pa-2",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "sm9": "",
      "offset-sm3": ""
    }
  }, [(_vm.lAction == 'view') ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.vehHeadSm : _vm.vehHead,
      "items": _vm.vehicles,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.updateVeh(props.item)
            }
          }
        }, [(_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.block_nm + ' ' + props.item.unit_no))]) : _vm._e(), _vm._v(" "), _c('td', [_c('v-icon', [_vm._v(_vm._s(props.item.veh_type === 'Car' ? 'directions_car' : 'directions_bike'))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.veh_no))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.has_got_sticker ? 'Yes' : 'No'))])])]
      }
    }], null, false, 1971337146)
  }) : _vm._e(), _vm._v(" "), (_vm.lAction != 'view') ? _c('v-form', {
    ref: "frmVeh",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateAndSave()
      }
    }
  }, [(_vm.lAction) ? _c('v-card', {
    staticClass: "mt-2"
  }, [(_vm.lAction === 'create') ? _c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("Create Vehicle")]) : _vm._e(), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("Vehicle Details")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.config.USER_HAS_MORE_UNITS) ? _c('v-select', {
    attrs: {
      "label": "Unit",
      "items": _vm.config.UNITS,
      "item-text": "block_and_unit",
      "item-value": "unit_id",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.vehicle.unit_id),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "unit_id", $$v)
      },
      expression: "vehicle.unit_id"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Type",
      "items": _vm.vehicleTypes,
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.vehicle.veh_type),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "veh_type", $$v)
      },
      expression: "vehicle.veh_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Number",
      "rules": [_vm.rules.required],
      "maxlength": "15"
    },
    model: {
      value: (_vm.vehicle.veh_no),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "veh_no", $$v)
      },
      expression: "vehicle.veh_no"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Has got parking sticker"
    },
    model: {
      value: (_vm.vehicle.has_got_sticker),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "has_got_sticker", $$v)
      },
      expression: "vehicle.has_got_sticker"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelVeh($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteVeh($event)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-alert', {
    staticClass: "mt-5",
    attrs: {
      "outline": "",
      "color": "info",
      "value": true
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "transparent"
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("Your declaration helps! How?")]), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "pl-3"
  }, [_c('li', [_vm._v("For better & seamless security checks")]), _vm._v(" "), _c('li', [_vm._v("Hasle-free parking management")])])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.config.IS_OTHER_USER) ? _c('v-tab-item', {
    key: 3
  }, [_c('v-container', {
    staticClass: "pa-2",
    attrs: {
      "grid-list-md": ""
    }
  }, [(_vm.dailyHelpAction == 'view') ? _c('v-layout', [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "sm9": "",
      "offset-sm3": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.dhHeadSm : _vm.dhHead,
      "items": _vm.myDailyHelps,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.viewDailyHelp(props.item)
            }
          }
        }, [_c('td', [_c('v-avatar', {
          staticClass: "my-1",
          attrs: {
            "slot": "activator",
            "size": "45px"
          },
          slot: "activator"
        }, [_c('img', {
          attrs: {
            "src": _vm.config.STATIC_FILES_DIR + props.item.visitor_img_url
          }
        })])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.visitor_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.visitor_phone))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.visitor_sub_cat))]) : _vm._e()])]
      }
    }], null, false, 2113418656)
  }), _vm._v(" "), _c('v-alert', {
    staticClass: "mt-5 pa-2",
    attrs: {
      "outline": "",
      "color": "info",
      "value": true
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "transparent"
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("Daily helpers of your unit!")]), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "pl-3"
  }, [_c('li', [_vm._v("List is updated when security guard adds/deletes a helper behalf your unit")]), _vm._v(" "), _c('li', [_vm._v("Don't forget to report/delete when your helper no more works for you")]), _vm._v(" "), _c('li', [_vm._v("\n                Employing a maid? Click on + button and pick the one from list\n              ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Get notified when your helper checks in/out at gate")]), _vm._v(" "), _c('li', [_vm._v("For better & seamless security checks")])])])])], 1)], 1)], 1)], 1) : _c('v-layout', [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "sm9": "",
      "offset-sm3": ""
    }
  }, [_c('v-card-title', {
    staticClass: "px-0 pt-0 pb-1 title"
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dailyHelpAction = 'view'
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v("\n        Add Daily Helper\n      ")], 1), _vm._v(" "), _c('v-expansion-panel', _vm._l((_vm.dailyHelpList.stats), function(item, i) {
    return _c('v-expansion-panel-content', {
      key: i,
      scopedSlots: _vm._u([{
        key: "header",
        fn: function() {
          return [_c('div', {
            staticClass: "title"
          }, [_c('b', [_vm._v(_vm._s(item.visitor_sub_cat) + " (" + _vm._s(item.tot_rec) + ")")])])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._l((_vm.dailyHelpList.detail.filter(function (rec) { return rec.visitor_sub_cat === item.visitor_sub_cat; })), function(helper, d) {
      return _c('div', [_c('v-card', {
        staticClass: "ma-2"
      }, [_c('v-card-text', {
        staticClass: "pb-2"
      }, [_c('v-layout', {
        attrs: {
          "row": "",
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs3": "",
          "sm2": "",
          "md1": ""
        }
      }, [_c('v-avatar', {
        staticClass: "mt-2 grey lighten-4",
        attrs: {
          "slot": "activator",
          "size": "65px"
        },
        slot: "activator"
      }, [_c('img', {
        attrs: {
          "src": _vm.config.STATIC_FILES_DIR + helper.visitor_img_url
        }
      })])], 1), _vm._v(" "), _c('v-flex', {
        class: _vm.$vuetify.breakpoint.smAndUp ? 'pl-3' : '',
        attrs: {
          "xs7": "",
          "sm9": "",
          "md10": ""
        }
      }, [_c('div', {
        staticClass: "subheading"
      }, [_c('strong', [_vm._v(_vm._s(helper.visitor_name))])]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: " caption info--text"
      }, [_vm._v(_vm._s(helper.visitor_sub_cat.toUpperCase()))]), _vm._v(" "), _c('v-chip', {
        staticClass: "caption black--text mx-0",
        attrs: {
          "small": "",
          "disabled": ""
        }
      }, [_vm._v("Works in " + _vm._s(helper.tot_linked_units) + " unit" + _vm._s(helper.tot_linked_units === 1 ? '' : 's'))])], 1), _vm._v(" "), _c('v-card', {
        attrs: {
          "flat": ""
        },
        on: {
          "click": function($event) {
            return _vm.showDailyHelpRating(false, helper)
          }
        }
      }, [_c('v-rating', {
        attrs: {
          "size": "20",
          "color": "warning",
          "background-color": "grey",
          "dense": "",
          "readonly": ""
        },
        model: {
          value: (helper.avg_overall_rating),
          callback: function($$v) {
            _vm.$set(helper, "avg_overall_rating", $$v)
          },
          expression: "helper.avg_overall_rating"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "info--text caption"
      }, [_c('a', {
        staticClass: "mr-3"
      }, [_vm._v(_vm._s(helper.no_of_rating) + " rating" + _vm._s(_vm.lRatings.no_of_rating === 1 ? '' : 's'))]), _vm._v(" "), _c('a', [_vm._v(_vm._s(helper.no_of_review) + " review" + _vm._s(helper.no_of_review === 1 ? '' : 's'))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
        staticClass: "text-xs-right",
        attrs: {
          "xs2": "",
          "sm1": "",
          "md1": ""
        }
      }, [_c('v-btn', {
        staticClass: "mt-4 grey lighten-4",
        attrs: {
          "icon": ""
        }
      }, [_c('a', {
        staticStyle: {
          "text-decoration": "none"
        },
        attrs: {
          "href": 'tel:' + item.visitor_phone
        }
      }, [_c('v-icon', [_vm._v("phone")])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.myDailyHelps.length && _vm.myDailyHelps.findIndex(function (rec) { return rec.easypass_id === helper.easypass_id; }) >= 0) ? _c('div', {
        staticClass: "grey--text caption"
      }, [_vm._v("Already linked to your unit")]) : _c('v-btn', {
        attrs: {
          "small": "",
          "flat": ""
        },
        on: {
          "click": function($event) {
            return _vm.addDailyHelper(helper)
          }
        }
      }, [_vm._v("Add to my unit")])], 1)], 1)], 1)
    })], 2)
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.tab === 2 && _vm.lAction === 'view') || (_vm.tab === 3 && _vm.dailyHelpAction === 'view')) ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab === 2 ? _vm.createVeh() : _vm.prepareAddDailyHelp()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px",
      "persistent": ""
    },
    model: {
      value: (_vm.viewDailyHelpDlg),
      callback: function($$v) {
        _vm.viewDailyHelpDlg = $$v
      },
      expression: "viewDailyHelpDlg"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 grey lighten-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.viewDailyHelpDlg = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0 text-xs-center"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "title",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lDailyHelp.visitor_name) + "\n              ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lDailyHelp.visitor_sub_cat) + "\n              ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-avatar', {
    staticClass: "grey lighten-4",
    attrs: {
      "size": 120
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.config.STATIC_FILES_DIR + _vm.lDailyHelp.visitor_img_url
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "black--text",
    attrs: {
      "small": "",
      "disabled": true
    }
  }, [_vm._v("Works in " + _vm._s(_vm.lDailyHelp.tot_linked_units) + " unit" + _vm._s(_vm.lDailyHelp.tot_linked_units === 1 ? '' : 's'))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lRatings) ? _c('v-card', [_c('v-card-text', {
    staticClass: "pa-2",
    on: {
      "click": function($event) {
        return _vm.showDailyHelpRating(!_vm.lRatings.no_of_rating)
      }
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "30",
      "color": "warning",
      "background-color": "grey",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: (_vm.lRatings.avg_overall_rating),
      callback: function($$v) {
        _vm.$set(_vm.lRatings, "avg_overall_rating", $$v)
      },
      expression: "lRatings.avg_overall_rating"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info--text caption"
  }, [_c('a', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.lRatings.no_of_rating) + " rating" + _vm._s(_vm.lRatings.no_of_rating === 1 ? '' : 's'))]), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.lRatings.no_of_review) + " review" + _vm._s(_vm.lRatings.no_of_review === 1 ? '' : 's'))])])], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "caption grey--text",
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.showDailyHelpRating(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.lRatings.myratings ? ('You rated on ' + _vm.handy.formatDate(_vm.lRatings.myratings.rated_on)) : (_vm.lRatings.no_of_rating ? '' : 'Be the first one. ') + 'Review now!')), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.showRepDelDailyHelp()
      }
    }
  }, [_vm._v("Report/Delete")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400px"
    },
    model: {
      value: (_vm.rateDailyHelpDlg),
      callback: function($$v) {
        _vm.rateDailyHelpDlg = $$v
      },
      expression: "rateDailyHelpDlg"
    }
  }, [(_vm.beingRated && _vm.lRatings) ? _c('v-card', [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n      My feedback for " + _vm._s(_vm.lDailyHelp.visitor_name) + "\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Overall satisfaction")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "dense": ""
    },
    model: {
      value: (_vm.rDailyHelp.overall_rating),
      callback: function($$v) {
        _vm.$set(_vm.rDailyHelp, "overall_rating", $$v)
      },
      expression: "rDailyHelp.overall_rating"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-2"
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Skillful")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "dense": ""
    },
    model: {
      value: (_vm.rDailyHelp.skill),
      callback: function($$v) {
        _vm.$set(_vm.rDailyHelp, "skill", $$v)
      },
      expression: "rDailyHelp.skill"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Regular")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "dense": ""
    },
    model: {
      value: (_vm.rDailyHelp.regular),
      callback: function($$v) {
        _vm.$set(_vm.rDailyHelp, "regular", $$v)
      },
      expression: "rDailyHelp.regular"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("So loyal")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "dense": ""
    },
    model: {
      value: (_vm.rDailyHelp.loyal),
      callback: function($$v) {
        _vm.$set(_vm.rDailyHelp, "loyal", $$v)
      },
      expression: "rDailyHelp.loyal"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Easy going person")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "dense": ""
    },
    model: {
      value: (_vm.rDailyHelp.easygoing),
      callback: function($$v) {
        _vm.$set(_vm.rDailyHelp, "easygoing", $$v)
      },
      expression: "rDailyHelp.easygoing"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2 mb-3"
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Review",
      "hide-actions": "",
      "rows": "3",
      "maxlength": "250",
      "counter": "250",
      "placeholder": "Optional",
      "hint": "Your review will be visible to others, not personal details",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.rDailyHelp.review),
      callback: function($$v) {
        _vm.$set(_vm.rDailyHelp, "review", $$v)
      },
      expression: "rDailyHelp.review"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.rateDailyHelpDlg = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.rateDailyHelp()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1) : (_vm.lRatings) ? _c('v-card', [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n      " + _vm._s(_vm.lDailyHelp.visitor_name) + " (" + _vm._s(_vm.lDailyHelp.visitor_sub_cat) + ")\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.rateDailyHelpDlg = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Overall satisfaction")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.lRatings.avg_overall_rating),
      callback: function($$v) {
        _vm.$set(_vm.lRatings, "avg_overall_rating", $$v)
      },
      expression: "lRatings.avg_overall_rating"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-2"
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Skillful")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.lRatings.avg_skill),
      callback: function($$v) {
        _vm.$set(_vm.lRatings, "avg_skill", $$v)
      },
      expression: "lRatings.avg_skill"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Regular")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.lRatings.avg_regular),
      callback: function($$v) {
        _vm.$set(_vm.lRatings, "avg_regular", $$v)
      },
      expression: "lRatings.avg_regular"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("So loyal")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.lRatings.avg_loyal),
      callback: function($$v) {
        _vm.$set(_vm.lRatings, "avg_loyal", $$v)
      },
      expression: "lRatings.avg_loyal"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Easy going person")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.lRatings.avg_easygoing),
      callback: function($$v) {
        _vm.$set(_vm.lRatings, "avg_easygoing", $$v)
      },
      expression: "lRatings.avg_easygoing"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2 mb-3"
  }), _vm._v(" "), (_vm.lRatings.no_of_review) ? _c('v-flex', {
    staticClass: "subheading",
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.lRatings.detail), function(rec, i) {
    return _c('div', {
      key: i
    }, [_c('span', {
      staticClass: "caption grey--text"
    }, [_vm._v("A review posted on " + _vm._s(_vm.handy.formatDate(rec.rated_on)) + "\n              "), _c('v-rating', {
      attrs: {
        "size": "15",
        "color": "accent",
        "background-color": "grey",
        "readonly": "",
        "dense": ""
      },
      model: {
        value: (rec.overall_rating),
        callback: function($$v) {
          _vm.$set(rec, "overall_rating", $$v)
        },
        expression: "rec.overall_rating"
      }
    })], 1), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "title info--text"
    }, [_vm._v("\"")]), _c('i', [_vm._v(_vm._s(rec.review))]), _c('span', {
      staticClass: "title info--text"
    }, [_vm._v("\"")])]), _vm._v(" "), (i < _vm.lRatings.detail.length - 1) ? _c('v-divider', {
      staticClass: "mx-3 my-2"
    }) : _vm._e()], 1)
  }), 0) : _c('v-flex', {
    staticClass: "text-xs-center caption",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n          No reviews yet!\n        ")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px",
      "persistent": ""
    },
    model: {
      value: (_vm.repDailyHelpDlg),
      callback: function($$v) {
        _vm.repDailyHelpDlg = $$v
      },
      expression: "repDailyHelpDlg"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v(_vm._s(_vm.lDailyHelp.visitor_name) + " (" + _vm._s(_vm.lDailyHelp.visitor_sub_cat) + ")")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-radio-group', {
    attrs: {
      "hide-details": ""
    },
    model: {
      value: (_vm.lDailyHelp.rep_del_reason),
      callback: function($$v) {
        _vm.$set(_vm.lDailyHelp, "rep_del_reason", $$v)
      },
      expression: "lDailyHelp.rep_del_reason"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Delete as ' + (_vm.lDailyHelp.gender === 'Female' ? 'she' : 'he') + ' does not work for us any more',
      "value": "D"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": 'Report & delete as ' + (_vm.lDailyHelp.gender === 'Female' ? 'she' : 'he') + ' is wrongly linked to our unit',
      "value": "R"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.repDailyHelpDlg = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.repDelDailyHelp()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "310px"
    },
    model: {
      value: (_vm.vdoDlg),
      callback: function($$v) {
        _vm.vdoDlg = $$v
      },
      expression: "vdoDlg"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('video', {
    staticStyle: {
      "width": "280px",
      "height": "210px"
    },
    attrs: {
      "id": "cam",
      "autoplay": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center pb-3 pt-0"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.capturePhoto
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("camera")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "15px",
      "right": "10px"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "grey",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeVdoDlg($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 4000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/26.f7bc05750d460613d41b.js